
import { mixins, Options } from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { maska } from 'maska'
import { IDateRangePicker } from '@/utils/types'
import { ACTION_APP } from '@/store/actions'
import AppMixin from '@/components/app/mixins/AppMixin.vue'
import OverviewCardMixin from './mixins/OverviewCardMixin.vue'
import CLoading from '@/components/common/ui/CLoading.vue'
import BaseFormMixin from '../common/mixins/BaseFormMixin.vue'
import DateRangeSelectorV2 from '@/components/common/ui/DateRangeSelectorV2.vue'
import { DatetimeUtils } from '@/utils/datetime'
import { UserTable, PopupTable, RichMenuTable, CommonMessagesTable, StoryTable, FormTable } from './tables'
import OverviewCard from './OverviewCard.vue'
import { MESSAGE_TYPE } from '@/utils/constants'

@Options({
  components: {
    DateRangeSelectorV2,
    CLoading,
    UserTable,
    PopupTable,
    RichMenuTable,
    CommonMessagesTable,
    OverviewCard,
    StoryTable,
    FormTable,
  },
  directives: { maska },
  async beforeRouteLeave() {
    if (!this) {
      return
    }
    const result = await this.checkDraftValue()
    if (result) {
      return true
    } else {
      return false
    }
  },
})
export default class OverView extends mixins(AppMixin, BaseFormMixin, OverviewCardMixin) {
  loading = true

  dateRange: IDateRangePicker = {
    startDate: '',
    endDate: '',
  }

  MESSAGE_TYPE = MESSAGE_TYPE

  firstLoad = true

  async fetchSelectingApp() {
    this.resetCardData()

    if (!this.appId) {
      return
    }

    this.loading = true

    const resp = await this.$store.dispatch(ACTION_APP.OVERVIEW, {
      app_id: this.appId,
      is_test_mode: false,
      date_from: DatetimeUtils.formatDate(this.dateRange.startDate),
      date_to: DatetimeUtils.formatDate(this.dateRange.endDate),
    })
    if (resp) {
      this.updateCardData(resp)
    }

    this.loading = false
  }

  async changeDateRange(value) {
    if (this.firstLoad) {
      return
    }
    this.dateRange = value
    await this.fetchSelectingApp()
  }

  @Watch('appId', { immediate: true })
  async appIdChanged() {
    this.dateRange = DatetimeUtils.getDateRange('last7Days')
    await this.fetchSelectingApp()
    this.firstLoad = false
  }

  onDetails() {
    this.goto('overview_details', {
      app_id: this.appId,
      from_date: DatetimeUtils.formatDate(this.dateRange.startDate),
      to_date: DatetimeUtils.formatDate(this.dateRange.endDate),
    })
  }
}
